import {DeviceType, GameRules} from '@gongxigames/framework/slot';

export class RubyGameRules extends GameRules {
    protected load(): void {
        if (!this._needToLoad) {
            return;
        }
        const loader = this._resourceManager;
        const howToPlayText = !this.isPlatformDesktop() ? 'howToPlayMobileWithRubyCoins' : 'howToPlayWithRubyCoins';
        const templates = {
            gameRules: '',
            howToPlayMobile: '',
            howToPlay: ''
        };

        Promise.all([
            loader.loadHTMLTemplate('gameRules').then(template => {
                templates.gameRules = template;
            }),
            loader.loadTemplate(howToPlayText).then(template => {
                // @ts-ignore
                templates[howToPlayText] = template;
            }),
            this.createAutoplayOptionsPopupImageSource(),
            this.generateLocalizedImages()
            // @ts-ignore
        ]).then(() => this.loadCallback(templates.gameRules, templates[howToPlayText]));
        this._needToLoad = false;
    }

    protected loadCallback(gameRulesTemplate: string, howToPlayTemplate: string): void {
        if (gameRulesTemplate && howToPlayTemplate) {
            this.insertHtml(gameRulesTemplate, this._gameRules);
            this.insertHtml(howToPlayTemplate, document.querySelector('#gameRules .howtoplay'));

            if (this._languageService.get('translationsGameTerminology') === 'undefined') {
                document.getElementById('translationsGameTerminology')!.style.display = 'none';
            }
            (document.querySelector('#gameRules .close') as any).onclick = this.close.bind(this);

            if (this.settings.get('ukRegulations')) {
                (document.querySelector('#gameRules .with-uk-regs') as any).style.display = 'block';
                (document.querySelector('#gameRules .without-uk-regs') as any).style.display = 'none';
                (document.querySelector('#gameRules .with-uk-regs-GR-description') as any).style.display = 'block';
                (document.querySelector('#gameRules .without-uk-regs-GR-description') as any).style.display = 'none';
            } else {
                (document.querySelector('#gameRules .with-uk-regs') as any).style.display = 'none';
                (document.querySelector('#gameRules .without-uk-regs') as any).style.display = 'block';
                (document.querySelector('#gameRules .with-uk-regs-GR-description') as any).style.display = 'none';
                (document.querySelector('#gameRules .without-uk-regs-GR-description') as any).style.display = 'block';
            }
            this._loaded = true;
            this._isOpen && this.open();
            this.isPlatform(DeviceType.DESKTOP) && this.createCustomScroll();

            this.attachSearchField();
        } else {
            this._needToLoad = true;
            this._isOpen = false;
        }
    }
}
